import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/pinRetrievalRequests';

const initialState = fromJS({
  pinRetrievalRequests: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  pinRetrievalRequestDetails: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  pendingRetrievalRequestsCount: 0,
  pendingRetrievalRequests: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  pinRetrievalConfiguration: {
    data: {},
    state: null
  }
});

const JustAppraisedReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PIN_RETRIEVAL_REQUESTS[START]: {
      return state.setIn(
        ['pinRetrievalRequests', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_PIN_RETRIEVAL_REQUESTS[SUCCESS]: {
      return state
        .setIn(['pinRetrievalRequests', 'state'], fetchingState.LOADED)
        .setIn(
          ['pinRetrievalRequests', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['pinRetrievalRequests', 'totalRecords'],
          fromJS(action.data ? action.data.recordCount : []),
        );
    }
    case actions.FETCH_PIN_RETRIEVAL_REQUESTS[ERROR]: {
      return state.setIn(
        ['pinRetrievalRequests', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[START]: {
      return state.setIn(
        ['pinRetrievalRequestDetails', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[SUCCESS]: {
      return state
        .setIn(['pinRetrievalRequestDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['pinRetrievalRequestDetails', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['pinRetrievalRequestDetails', 'totalRecords'],
          fromJS(action.data ? action.data.recordCount : []),
        );
    }
    case actions.FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[ERROR]: {
      return state.setIn(
        ['pinRetrievalRequestDetails', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_PENDING_RETRIEVAL_REQUESTS[START]: {
      return state.setIn(['pendingRetrievalRequests', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PENDING_RETRIEVAL_REQUESTS[SUCCESS]: {
      return state
        .setIn(['pendingRetrievalRequests', 'state'], fetchingState.LOADED)
        .setIn(
          ['pendingRetrievalRequests', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['pendingRetrievalRequests', 'totalRecords'],
          fromJS(action.data ? action.data.recordCount : []),
        );
    }
    case actions.FETCH_PENDING_RETRIEVAL_REQUESTS[ERROR]: {
      return state.setIn(['pendingRetrievalRequests', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT[SUCCESS]: {
      return state
        .setIn(
          ['pendingRetrievalRequestsCount'],
          action.data ? action.data.results[0].pendingRequests : 0,
        );
    }

    case actions.FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[START]:
    case actions.UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[START]: {
      return state.setIn(['pinRetrievalConfiguration', 'state'], fetchingState.FETCHING);
    }

    case actions.FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[SUCCESS]:
    case actions.UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[SUCCESS]: {
      return state
        .setIn(['pinRetrievalConfiguration', 'state'], fetchingState.LOADED)
        .setIn(
          ['pinRetrievalConfiguration', 'data'],
          fromJS(action.data ? action.data.results : {})
        );
    }

    case actions.FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[ERROR]:
    case actions.UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[ERROR]: {
      return state.setIn(['pinRetrievalConfiguration', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default JustAppraisedReducer;
